import { render, staticRenderFns } from "./ClientTableWidget.vue?vue&type=template&id=2b998045"
import script from "./ClientTableWidget.vue?vue&type=script&lang=js"
export * from "./ClientTableWidget.vue?vue&type=script&lang=js"
import style0 from "./ClientTableWidget.vue?vue&type=style&index=0&id=2b998045&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports